<div [class]="isMobile ? 'slider-wrap-mobile' : 'slider-wrap'">
  <div id="card-slider" class="slider">
    <div style="cursor: pointer; transform: translate(0px, -300px);" (click)="goToAnnonce(annonce.idannonce)" [class]="isMobile ? 'slider-item-mobile' : 'slider-item'" *ngFor="let annonce of annonces">
      <div class="animation-card_image">
        <img [src]="annonce.societe_logo" alt="">
      </div>
      <div class="animation-card_content">
        <h4 class="animation-card_content_title title-2" style="white-space: pre-line; "><b>{{lowText(annonce.intitule, 22)}}</b></h4>
        <p class="animation-card_content_city">
          {{ annonce.code_postal }} {{ lowText(annonce.ville, 50) }} ● {{ lowText(annonce.regions, 20) }} ● {{ annonce.contrats }}
          {{ (config('topannonce_ref')?._view ? '● Ref : ' + lowText(annonce.ref, 30) : '') }}
        </p>
      </div>
    </div>
  </div>
</div>  
